import { I18n } from '@/i18n/I18n';
import { CheckResult, describeCheck } from './expectations';
import { FixtureResult } from './types';

/** A check that missed, in a line: what it holds the report to, and what it found instead. */
export function describeCheckMiss(result: CheckResult): string {
  return result.check ? `${describeCheck(result.check)}: ${result.message ?? ''}` : `${result.from}: ${result.message ?? ''}`;
}

/**
 * A fixture that holds the bundle back, said so its author knows what to
 * change: what it expects, what it came to, and the findings that put it there;
 * or the checks that missed.
 */
export function describeFixtureMiss(result: FixtureResult): string {
  const expected = result.expected?.verdictLabel ?? result.expected?.verdict;
  const actual = result.verdictLabel ?? result.verdict;
  const missedChecks = (result.checks ?? []).filter((c) => !c.ok);
  const checks = missedChecks.length
    ? I18n.get(missedChecks.length === 1 ? 'reportBundleFixtureCheckMissed' : 'reportBundleFixtureChecksMissed', { file: result.file, count: String(missedChecks.length), checks: missedChecks.slice(0, 3).map(describeCheckMiss).join('; ') })
    : null;
  const broken = I18n.get('reportBundleFixtureBroken', { file: result.file, error: result.error ?? I18n.get('failed') });
  if (!actual) return broken;
  const verdictHeld = (result.expected?.verdict === undefined || result.expected.verdict === result.verdict)
    && (result.expected?.verdictLabel === undefined || result.expected.verdictLabel === result.verdictLabel);
  if (!expected || verdictHeld) return checks ?? broken;
  const reasons = result.reasons ?? [];
  const miss = reasons.length
    ? I18n.get('reportBundleFixtureMissBecause', { file: result.file, expected, actual, reasons: reasons.join('; ') })
    : I18n.get('reportBundleFixtureMiss', { file: result.file, expected, actual });
  return checks ? `${miss} ${checks}` : miss;
}
